<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'
import type { ChipColor } from '@/components/base/BaseChip.vue'

interface UsageTag {
  label?: string
  value?: string
  color?: ChipColor
  icon?: Icons
}

interface Props {
  usageTags?: UsageTag[]
}

withDefaults(defineProps<Props>(), {
  usageTags: () => []
})

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <BaseChip v-if="usageTags.length == 0" :text="t('pages.reward.summary.noUsage')" color="gray" />
    <template v-else>
      <BaseChip
        v-for="tag in usageTags"
        :key="tag?.label || tag?.value || Math.random()"
        :icon="tag?.icon || 'HeroQuestionMarkCircleIconOutline'"
        :text="tag?.label || '-'"
        :color="tag?.color || 'gray'"
      />
    </template>
  </div>
</template>
